import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_62348685 from 'nuxt_plugin_plugin_62348685' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_plugin_676a58ee from 'nuxt_plugin_plugin_676a58ee' // Source: ./vuetify/plugin.js (mode: 'all')
import nuxt_plugin_cookieuniversalnuxt_76d29ac3 from 'nuxt_plugin_cookieuniversalnuxt_76d29ac3' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_distplugintemplate7e0df96a_81009820 from 'nuxt_plugin_distplugintemplate7e0df96a_81009820' // Source: ./dist.plugin.template.7e0df96a.js (mode: 'all')
import nuxt_plugin_axios_ad9eddca from 'nuxt_plugin_axios_ad9eddca' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_axios_3566aa80 from 'nuxt_plugin_axios_3566aa80' // Source: ../plugins/axios (mode: 'all')
import nuxt_plugin_api_5e4622e4 from 'nuxt_plugin_api_5e4622e4' // Source: ../plugins/api (mode: 'all')
import nuxt_plugin_i18n_1fba523a from 'nuxt_plugin_i18n_1fba523a' // Source: ../plugins/i18n.js (mode: 'all')
import nuxt_plugin_msal_6a83b8c7 from 'nuxt_plugin_msal_6a83b8c7' // Source: ../plugins/msal (mode: 'client')
import nuxt_plugin_graph_0dd1d942 from 'nuxt_plugin_graph_0dd1d942' // Source: ../plugins/graph.js (mode: 'client')
import nuxt_plugin_datepicker_f86071f6 from 'nuxt_plugin_datepicker_f86071f6' // Source: ../plugins/datepicker.js (mode: 'client')
import nuxt_plugin_colorpicker_7b02839c from 'nuxt_plugin_colorpicker_7b02839c' // Source: ../plugins/colorpicker.js (mode: 'client')
import nuxt_plugin_elementui_4171abdd from 'nuxt_plugin_elementui_4171abdd' // Source: ../plugins/elementui.js (mode: 'client')
import nuxt_plugin_vidle_38156de3 from 'nuxt_plugin_vidle_38156de3' // Source: ../plugins/vidle.js (mode: 'client')
import nuxt_plugin_loading_baa1819e from 'nuxt_plugin_loading_baa1819e' // Source: ../plugins/loading.js (mode: 'client')
import nuxt_plugin_globalutil_2e0995fc from 'nuxt_plugin_globalutil_2e0995fc' // Source: ../plugins/globalutil.js (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":true,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"titleTemplate":"GST M3 - %s","title":"","htmlAttrs":{"lang":"en","amp":true},"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"description","name":"description","content":""}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"},{"rel":"stylesheet","type":"text\u002Fcss","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss?family=Roboto:100,300,400,500,700,900&display=swap"},{"rel":"stylesheet","type":"text\u002Fcss","href":"https:\u002F\u002Fcdn.jsdelivr.net\u002Fnpm\u002F@mdi\u002Ffont@latest\u002Fcss\u002Fmaterialdesignicons.min.css"}],"style":[],"script":[{"innerHTML":"window.initMap = function(){\n      window.dispatchEvent(new Event('maps-module:loaded'));\n      window.addEventListener('maps-module:initiated', function(){\n        setTimeout(function(){\n          window.dispatchEvent(new Event('maps-module:loaded'));\n        });\n      });\n    }","type":"text\u002Fjavascript"},{"src":"\u002F\u002Fmaps.googleapis.com\u002Fmaps\u002Fapi\u002Fjs?key=AIzaSyDnCqlHgVv_C23CFiIYhS20l3qfP4BIxUk&libraries=places,visualization,drawing&callback=initMap","defer":true,"async":true}],"__dangerouslyDisableSanitizers":["script"]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      errPageReady: false,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        nuxt.errPageReady = false
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_62348685 === 'function') {
    await nuxt_plugin_plugin_62348685(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_676a58ee === 'function') {
    await nuxt_plugin_plugin_676a58ee(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_76d29ac3 === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_76d29ac3(app.context, inject)
  }

  if (typeof nuxt_plugin_distplugintemplate7e0df96a_81009820 === 'function') {
    await nuxt_plugin_distplugintemplate7e0df96a_81009820(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_ad9eddca === 'function') {
    await nuxt_plugin_axios_ad9eddca(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_3566aa80 === 'function') {
    await nuxt_plugin_axios_3566aa80(app.context, inject)
  }

  if (typeof nuxt_plugin_api_5e4622e4 === 'function') {
    await nuxt_plugin_api_5e4622e4(app.context, inject)
  }

  if (typeof nuxt_plugin_i18n_1fba523a === 'function') {
    await nuxt_plugin_i18n_1fba523a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_msal_6a83b8c7 === 'function') {
    await nuxt_plugin_msal_6a83b8c7(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_graph_0dd1d942 === 'function') {
    await nuxt_plugin_graph_0dd1d942(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_datepicker_f86071f6 === 'function') {
    await nuxt_plugin_datepicker_f86071f6(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_colorpicker_7b02839c === 'function') {
    await nuxt_plugin_colorpicker_7b02839c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_elementui_4171abdd === 'function') {
    await nuxt_plugin_elementui_4171abdd(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vidle_38156de3 === 'function') {
    await nuxt_plugin_vidle_38156de3(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_loading_baa1819e === 'function') {
    await nuxt_plugin_loading_baa1819e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_globalutil_2e0995fc === 'function') {
    await nuxt_plugin_globalutil_2e0995fc(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
